import api from "../lib/api";

const API_BASE =
  ((import.meta as any)?.env?.VITE_API_BASE_URL ||
    process.env.REACT_APP_API_BASE_URL ||
    "https://api.roott.one/api").replace(/\/$/, "");

export async function getDashboardOverview() {
  const res = await api.get(`${API_BASE}/dashboard/overview`, { baseURL: "" });
  return res.data;
}

export async function fetchProfileCompletion() {
  const res = await api.get(`${API_BASE}/users/profile/completion/`, { baseURL: "" });
  return res.data;
}
export async function getDashboardStats() {
  const res = await api.get("/dashboard/stats/");
  return res.data;
}

export async function getDashboardUpcomingDues() {
  const res = await api.get("/dashboard/upcoming-dues/");
  return res.data;
}

export async function getDashboardNextSteps() {
  const res = await api.get("/dashboard/next-steps/");
  return res.data;
}

export async function getDashboardMonthlySubmissions() {
  const res = await api.get("/dashboard/monthly-submissions/");
  return res.data;
}

export async function getDashboardGrantDistribution() {
  const res = await api.get("/dashboard/grant-distribution/");
  return res.data;
}

export async function getDashboardTopPicks() {
  const res = await api.get("/dashboard/top-picks/");
  return res.data;
}

export async function getDashboardTrending() {
  const res = await api.get("/dashboard/trending/");
  return res.data;
}


export async function getDashboardAiInsight() {
  const res = await api.get("/dashboard/ai-insight/");
  return res.data;
}

export const createTeam = async (name: string) => {
  const { data } = await api.post("/users/team/create/", { name });
  return data;
};

export const inviteToTeam = async (payload: {
  email: string;
  team_id: number;
  role?: "admin" | "editor" | "viewer";
}) => {
  const { data } = await api.post("/users/team/invite/", payload);
  return data;
};

export const acceptTeamInvite = async (token: string) => {
  const { data } = await api.post(`/users/team/invite/accept/${token}/`);
  return data;
};

export const getTeamList = async () => {
  const { data } = await api.get("/users/team/list/");
  return data;
};

export const setActiveTeam = async (teamId: number | null) => {
  const body = {
    team_id: teamId === null ? "" : String(teamId),
  };

  const { data } = await api.post("/users/team/set-active/", body);
  return data;
};

export const switchTeam = async (team_id: number) => {
  const { data } = await api.post("/users/team/switch/", { team_id });
  return data;
};

export const deleteTeam = async (teamId: number) => {
  const { data } = await api.delete(`/users/profile/team/${teamId}/delete/`);
  return data;
};

export const deleteTeamMember = async (memberId: number) => {
  const { data } = await api.delete(
    `${API_BASE}/users/profile/team/members/delete/`,
    {
      params: { id: memberId },
      baseURL: "",
    }
  );
  return data;
};